<div id="kt_header_mobile" class="header-mobile align-items-center" style="background-color:#ffffff">
  <a href="./client/forms" style="display:none;">
    <img alt="Logo" src="assets/media/logo/dhslogocolor350.png" />
  </a>
</div>

<div id="kt_header" class="header">
  <div class="container-fluid d-flex align-items-stretch justify-content-between">
    <div class="header-menu-wrapper header-menu-wrapper-left" id="kt_header_menu_wrapper">
      <div class="header-logo" >
        <a style="display:none;">
          <img alt="Logo" src="assets/media/logo/dhslogocolor350.png" />
        </a>
      </div>
    </div>
  </div>
</div>
<div class="content d-flex flex-column flex-column-fluid" id="kt_content">
  <div class="d-flex flex-column-fluid">
    <div class="container">
      <ng-container class="mt-20">
        <form action="#">
          <div class="row">
            <div class="col-8 offset-2 col-md-8 col-sm-12">
              <div class="card card-body">
                <div class="row justify-content-center my-8">
                  <!--begin: Pricing-->
                  <div class="col-md-12 col-xxl-12">
                    <div class="pt-30 pt-md-25 pb-15 px-5 text-center">
                      <!--begin::Icon-->
                      <div class="d-flex flex-center position-relative mb-25">
                        <span class="svg svg-fill-success opacity-4 position-absolute">
                          <svg width="175" height="200">
                            <polyline points="87,0 174,50 174,150 87,200 0,150 0,50 87,0"></polyline>
                          </svg>
                        </span>
                        <span class="svg-icon svg-icon-danger svg-icon-7x">
                          <!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-05-14-112058/theme/html/demo1/dist/../src/media/svg/icons/Home/Timer.svg--><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                              <rect x="0" y="0" width="24" height="24" />
                              <path d="M12,21 C7.581722,21 4,17.418278 4,13 C4,8.581722 7.581722,5 12,5 C16.418278,5 20,8.581722 20,13 C20,17.418278 16.418278,21 12,21 Z" fill="#000000" opacity="0.3" />
                              <path d="M13,5.06189375 C12.6724058,5.02104333 12.3386603,5 12,5 C11.6613397,5 11.3275942,5.02104333 11,5.06189375 L11,4 L10,4 C9.44771525,4 9,3.55228475 9,3 C9,2.44771525 9.44771525,2 10,2 L14,2 C14.5522847,2 15,2.44771525 15,3 C15,3.55228475 14.5522847,4 14,4 L13,4 L13,5.06189375 Z" fill="#000000" />
                              <path d="M16.7099142,6.53272645 L17.5355339,5.70710678 C17.9260582,5.31658249 18.5592232,5.31658249 18.9497475,5.70710678 C19.3402718,6.09763107 19.3402718,6.73079605 18.9497475,7.12132034 L18.1671361,7.90393167 C17.7407802,7.38854954 17.251061,6.92750259 16.7099142,6.53272645 Z" fill="#000000" />
                              <path d="M11.9630156,7.5 L12.0369844,7.5 C12.2982526,7.5 12.5154733,7.70115317 12.5355117,7.96165175 L12.9585886,13.4616518 C12.9797677,13.7369807 12.7737386,13.9773481 12.4984096,13.9985272 C12.4856504,13.9995087 12.4728582,14 12.4600614,14 L11.5399386,14 C11.2637963,14 11.0399386,13.7761424 11.0399386,13.5 C11.0399386,13.4872031 11.0404299,13.4744109 11.0414114,13.4616518 L11.4644883,7.96165175 C11.4845267,7.70115317 11.7017474,7.5 11.9630156,7.5 Z" fill="#000000" />
                            </g>
                          </svg><!--end::Svg Icon-->
                        </span>
                      </div>
                      <!--end::Icon-->
                      <!--begin::Content-->
                      <div *ngIf="isSpanishlanguage() != true">
                        <span class="font-weight-bolder text-dark font-size-h2 font-size-h1-lg d-block py-2">Case Expired!</span>
                        <h4 class="font-size-h6 d-block d-block font-weight-bold mb-7 text-dark">{{token.caseNumber}}</h4>
                        <p class="mb-15 d-flex flex-column text-left text-secondary font-weight-bold font-size-h4">
                          <span>The review for case # <strong>{{token.caseNumber}} </strong> was due <strong>{{token.reDueDate |  date: 'mediumDate'}} </strong> which is more than 90 days ago.</span><br />
                          <span>  Reviews can only be submitted if the due date was less than 90 days ago. For any questions, please contact your worker for further assistance.</span>
                        </p>
                      </div>
                      <!--end::Content-->
                      <div *ngIf="isSpanishlanguage() == true">
                        <span class="font-weight-bolder text-dark font-size-h2 font-size-h1-lg d-block py-2">caso expiro!</span>
                        <h4 class="font-size-h6 d-block d-block font-weight-bold mb-7 text-dark">{{token.caseNumber}}</h4>
                        <p class="mb-15 d-flex flex-column text-left text-secondary font-weight-bold font-size-h4">
                          <span>La revision del caso # <strong>{{token.caseNumber}} </strong> vencio <strong>{{token.reDueDate |  date: 'mediumDate'}} </strong> hace mas de 90 dias.</span><br />
                          <span>Las resenas solo se pueden enviar si la fecha de vencimiento fue hace menos de 90 dias. Si tiene alguna pregunta, comuniquese con su trabajador para obtener mas ayuda.</span>
                        </p>
                      </div>

                    </div>
                  </div>
                  <!--end: Pricing-->
                </div>
              </div>
            </div>
          </div>
        </form>
      </ng-container>
    </div>
  </div>
</div>
<div class="footer bg-white py-4 d-flex flex-lg-column" id="kt_footer">
  <div class="container-fluid d-flex flex-column flex-md-row align-items-center justify-content-between">
    <div class="text-dark order-2 order-md-1">
      <span class="font-weight-bold mr-2">{{ currentYear }}</span>
      <a href="https://dhs.iowa.gov/" target="_blank" class="text-dark-75 text-hover-primary">IOWA Department of Human Service</a>
    </div>
    <div class="nav nav-dark">
    </div>
  </div>
</div>
